// extracted by mini-css-extract-plugin
export default {"nameButton":"VmsTable_nameButton__dehOW"};